module.exports = __webpack_public_path__ + "static/media/down-arrow.bd19d992.svg";